import { Dispatch, createContext, useContext } from 'react';
import { DraftAction } from '@/components/draft/draftState/types';

export const DraftContext = createContext<Dispatch<DraftAction>>(console.log);

export const useDraftDispatch = () => useContext(DraftContext);
